<div class="container">
  <div class="blue-section">
    <img *ngIf="blueSectionState === 'login'" class="fleetr-logo" src="/assets/img/fleetr-logo-white.svg" alt="">

    <div class="mail-logo-section" *ngIf="blueSectionState === 'magicLink'">
      <h2>{{ 'GET_MAGIC_LINK' | translation }}</h2>
      <img class="mail-icon" src="/assets/img/mail.svg" alt="">
      <ng-container *ngIf="sent">
        <h3>{{ 'GET_MAGIC_LINK_SENT' | translation }}</h3>
        <p>{{ 'CHECK_EMAIL' | translation }} <strong>{{ emailSent }}</strong> {{ 'TO_GET_IN' | translation }}</p>
      </ng-container>
    </div>

    <div class="mail-logo-section" *ngIf="blueSectionState === 'forgotPassword'">
      <h2>{{ 'RECOVER_PASSWORD' | translation }}</h2>
      <img class="mail-icon" src="/assets/img/mail.svg" alt="">
      <ng-container *ngIf="sent">
        <h3>{{ 'RECOVER_PASSWORD_SENT' | translation }}</h3>
        <p>{{ 'CHECK_EMAIL' | translation }} <strong>{{ emailSent }}</strong> {{ 'TO_RECOVER_PASSWORS' | translation }}</p>
      </ng-container>
    </div>
  </div>

  <div class="form-section">
    <form [formGroup]="loginForm" (ngSubmig)="login()">
      <div class="fp-titles text-center" *ngIf="loginState === 'forgotPassword'">
        <div class="title"> {{ 'CHANGE_PASS_TITLE' | translation }} </div>
        <div class="subtitle"> {{ 'CHANGE_PASS_SUBTITLE' | translation }} </div>
      </div>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{translate.transform('EMAIL')}}</mat-label>
        <input type="text" matInput formControlName="email">
        <div class="error-tooltip" *ngIf="emailError">
          {{ 'INTRODUCE_EMAIL' | translation }}
        </div>
        <div class="error-tooltip" *ngIf="emailError">
          {{ 'INTRODUCE_VALID_EMAIL' | translation }}
        </div>
      </mat-form-field>

      <div class="login-state" *ngIf="loginState === 'login'">
        <div class="tooltip-spacer" *ngIf="passwordError"></div>
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>{{translate.transform('PASSWORD')}}</mat-label>
          <input type="password" matInput formControlName="password">
          <div class="error-tooltip" *ngIf="passwordError">
            {{ 'INTRODUCE_PASSWORD' | translation }}
          </div>
        </mat-form-field>

        <button [disabled]="disableButton" *ngIf="loginState === 'login'"
          class="full-width button" mat-raised-button (click)="login()">
          {{ 'LOGIN' | translation }}
        </button>
        <p class="forgot-pass text-center" (click)="changeLoginState('forgotPassword')">
          {{ 'FORGOT_PASSWORD' | translation }}
        </p>
        <p class="magic-link text-center" (click)="changeLoginState('magicLink')">
          {{ 'GET_MAGIC_LINK' | translation }}
        </p>
      </div>

      <div class="fp-state" *ngIf="loginState === 'forgotPassword'">
        <p class="text-center danger" *ngIf="changePasswordError">
          {{ changePasswordError | translation }}
        </p>
        <button [disabled]="disableButton" *ngIf="!sent" class="full-width button" mat-raised-button
          (click)="changePassword();">
          {{ 'CHANGE_PASSWORD' | translation }}
        </button>
        <button [disabled]="disableButton" *ngIf="sent" class="full-width button" mat-raised-button
          (click)="changePassword();">
          {{ 'CHANGE_PASSWORD_TRY_AGAIN' | translation }}
        </button>
        <p class="forgot-pass text-center" (click)="changeLoginState('login')">
          {{ 'BACK' | translation }}
        </p>
      </div>

      <div class="fp-state" *ngIf="loginState === 'magicLink'">
        <p class="text-center danger" *ngIf="magicLinkErr">
          {{ magicLinkErr | translation }}
        </p>
        <button [disabled]="disableButton" class="full-width button" mat-raised-button
          (click)="getMagicLink();">
          {{ 'GET_MAGIC_LINK_ACTION' | translation }}
        </button>
        <p class="forgot-pass text-center" (click)="changeLoginState('login')">
          {{ 'PASSWORD_LOGIN' | translation }}
        </p>
      </div>
      <br>
      <br>
    </form>
  </div>
</div>
